import type { ObjectOf } from '@app-types/global';

export const createPathWithParams = (path: string, params: ObjectOf<string>) => {
  let finalPath = path;
  Object.keys(params).forEach((key) => {
    finalPath = finalPath.replace(`:${key}`, params[key]);
  });
  return finalPath;
};

export const sanitizePathEdges = (path: string, where: 'start' | 'end'): string => {
  if (where === 'start') {
    return path.replace(/^\/+/, '');
  } else {
    return path.replace(/\/+$/, '');
  }
};
